import { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusCancelledIcon: FC<IconProps> = (props) => {
  const theme = useTheme();
  return (
    <Icon height="24px" {...props} viewBox="0 0 34 33">
      <circle
        opacity="0.1"
        cx="16.6749"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <path
        d="M16.8299 7C11.5268 7 7.17493 11.3519 7.17493 16.655C7.17493 21.9581 11.5268 26.31 16.8299 26.31C22.133 26.31 26.4849 21.9581 26.4849 16.655C26.4849 11.3519 22.133 7 16.8299 7ZM21.6303 19.8554L20.0303 21.4553L16.8299 18.2549L13.6295 21.4553L12.0296 19.8554L15.23 16.655L12.0296 13.4546L13.6295 11.8547L16.8299 15.0551L20.0303 11.8547L21.6303 13.4546L18.4299 16.655L21.6303 19.8554Z"
        fill={theme.colors.red}
      />
    </Icon>
  );
};
